import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ListDisplay } from '@warrenbrasil/nebraska-web';
import { Money } from '@/modules/common/components/Money';

import {
  EProductViewCardType,
  IProduct
} from '@/modules/products/services/products';

interface Props {
  card: IProduct;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCardFooter',
  props: {
    card: null
  },
  setup(__props: any) {

const props = __props as {
  card: IProduct;
};



const baseTextProps = computed(() =>
  props.card.type !== EProductViewCardType.Product
    ? {
        color: NebraskaColors.elementSecondary,
        class: 'default-footer'
      }
    : {
        color: NebraskaColors.elementPrimary
      }
);

return { __sfc: true,props, baseTextProps, NebraskaColors, BaseText, ListDisplay, Money }
}

})